(function ($, window, document, config) {
    "use strict";

    $('.integrate-slider').slick({
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        infinite: true,
        draggable: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    swipe: false
                }
            }
        ]
    });

    $('.testimonial-slider-init').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slide-arrow prev-arrow"><i class="fas fa-angle-left"></i></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><i class="fas fa-angle-right"></i></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });

    $('.testimonial-slider-init-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: true,
        prevArrow: '<button class="slide-arrow prev-arrow"><i class="fas fa-angle-left"></i></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><i class="fas fa-angle-right"></i></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    $('.signup-banner-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        infinite: true,
        draggable: true,
        dots: true,
    });

    $(document).ready(function () {
        const player = new Plyr('#preview-video', {
            title: '',
            controls: [
                'play', // Play/pause playback
                'progress', // The progress bar and scrubber for playback and buffering
                'current-time', // The current time of playback
                'duration', // The full duration of the media
                'mute', // Toggle mute
                'volume', // Volume control
                'settings', // Settings menu
                'fullscreen', // Toggle fullscreen
            ],
        });

        //
        // Studio Section tab slider
        let tabCount = -1,
            activeTab = $('.wp-ayyash-studio-tab__single'),
            activeContent = $('.wp-ayyash-studio-tab__content-single'),
            activeAccordion = $('.wp-ayyash-studio-tab__single .accordion-header .accordion-button'),

            activeAccordionBody = $('.wp-ayyash-studio-tab__single .accordion-collapse'),
            platyBtn = $('.preview-img .play-btn'),
            timeoutInterval = 5000;
        let timeTosec = Math.floor((timeoutInterval / 1000) % 60);


        // Tab and Tab Content Class toggle function
        function tabClassToggle() {
            // Change tab Count
            let tabLength = activeTab.length - 1;
            tabCount < tabLength ? tabCount++ : tabCount = 0;

            // change tabCount if clicked
            $(activeTab).click(function () {
                tabCount = $(this).index();
            });

            // Add and remove class for tab item
            activeTab.removeClass('active').eq(tabCount).addClass('active');

            activeContent.removeClass('active').eq(tabCount).addClass('active');

            activeAccordion.eq(tabCount).removeClass('collapsed');

            activeAccordionBody.collapse('hide').eq(tabCount).collapse('show');

            $(".wp-ayyash-studio-tab__single.active #circle-animation").css("animation-duration", timeTosec + "s");

            // Display active tab
            let currentTab = activeTab.eq(tabCount).attr('href');
            $('.wp-ayyash-studio-tab__content > div').removeClass('active');
            $(currentTab).addClass('active');

            return false;
        }

        // Setting timeout for Tab
        let timeout = setInterval(tabClassToggle, timeoutInterval);

        // Handle Click function for tab
        activeTab.on('click', function () {
            // Add and remove class for tab item
            activeTab.removeClass('active');
            $(this).addClass('active');
            // Display active tab
            let currentContentTab = $(this).attr('href');
            $('.wp-ayyash-studio-tab__content > div').removeClass('active');
            $(currentContentTab).addClass('active');

            // Reset TimeOut
            clearTimeout(timeout);
            $('.wp-ayyash-studio-tab__single.active #circle-animation').css('stroke', "transparent");
            // timeout = setInterval(tabClassToggle, timeoutInterval);
        });

        platyBtn.on('click', function () {
            clearTimeout(timeout);
        });


        let searchRequest, keyword, hasResults = false;
        const searchEl = $("input#keyword");
        const resultEl = $("#search_result");
        const resultWrap = $(".search_result_inner");

        searchEl.focus( () => {
            resultEl.show();
        } );

        $(document).on( 'click',  function( e ) {
            if ( ! $( e.target ).closest( '#search_result' ).length && ! $( e.target ).closest( '#keyword' ).length ) {
                resultEl.hide( function () {
                    if ( ! hasResults && ! keyword ) {
                        resultWrap.html('');
                    }
                });
            }
        } );

        searchEl.keyup(_.debounce( function() {

            resultEl.show();
            keyword = $(this).val();

            if ( ! keyword && ! hasResults ) {
                resultEl.hide();
                return;
            }

            if (keyword.length < 3) {
                hasResults =false;
                resultWrap.html( `<ul><li class="disabled">${config.min_3}</li></ul>`);
                return;
            }


            if ( hasResults ) {
                resultWrap.find( 'li.disabled' ).remove();
                resultWrap.find( 'ul' ).prepend( `<ul><li class="disabled">${config.wait}</li></ul>`);
            } else {
                resultWrap.html( `<ul><li class="disabled">${config.wait}</li></ul>`);
            }

            if ( searchRequest ) {
                searchRequest.abort();
            }

            searchRequest = $.ajax( {
                url: config.ajaxUrl,
                type: 'GET',
                data: {
                    action: 'ayyash_docs_search',
                    nonce: config.nonce,
                    keyword: $(this).val(),
                },
                success: function({ success, data } ) {
                    hasResults = success;
                    resultWrap.html(data);
                },
                error: function( data ) {
                    console.log(data);
                    resultWrap.html( `<ul><li class="disabled">${config.wrong}</li></ul>`);
                    hasResults =false;
                },
                done: () => {
                    searchRequest = null;
                }
            } );

        }, 200 ));

    });


    let currentVideo = '',
        template = wp.template('video-modal'),
        modal = $('#video-modal'),
        player;


    $(document).on('click', '.video-modal-trigger', function (e) {
        e.preventDefault();
        const data = $(this).data();

        if (data.hasOwnProperty('plyrEmbedId')) {
            if (currentVideo === data.plyrEmbedId) {
                modal.modal('show');
                return;
            }
            currentVideo = data.plyrEmbedId;
        }

        modal.find('.modal-body').html(template(data));
        // init only once for new video.
        modal.one('shown.bs.modal', function () {
            player = new Plyr('#video-player');
        });

        modal.modal('show');
    });

    $("button[data-dismiss=modal]").click(function () {
        $(".modal").modal('hide');
        player && player.pause();
    });

    /**
     * Subscription form
     */
    $('.wpayyash-form').on('submit', function(e) {
        e.preventDefault();
        let form = $(this), data = {}, messageEl = $(this).find('.wpayyash-response'), message;

        messageEl.html("<div class='alert alert-primary' role='alert'>" +"Adding your email address..." + "</div>");

        $.each( form.serializeArray(), function( _, kv ) {
            data[kv.name] = kv.value;
        });

        wp.ajax.post( 'acelle_mail_add_subscription', data ).then( function( r ) {
            if( 'string' === typeof r ) messageEl.html( formatAlert( r, 'success', true ) );
        } ).fail( function( e ) {
            messageEl.html( formatAlert( 'Something Went Wrong !', 'danger', true ) );
        } );
    });

    /**
     * Format Alert Message HTML
     * @param {string} message
     * @param {string} type
     * @param {boolean} dismissible
     * @returns {string}
     */
    let formatAlert = function ( message, type, dismissible ) {
        let html = '';
        html += '<div class="alert alert-'+type+' alert-dismissible fade show" role="alert">';
        if( dismissible ) html += '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';
        html += message;
        html += '</div>';
        return html;
    };

})(jQuery, window, document, wpAyyash);
